import { useContext, useEffect, useState } from "react";
import { OperationContext } from "../../CreateOperation";
import { OperationConstant } from "../../../../core/_constant";
import { CustomTabs } from "../../../../../../common/components/Tabs/CustomTabs";
import { BoardingContainerPointingList } from "./BoardingContainerPointingList";
import { BoardingBagPointingList } from "./BoardingBagPointingList";
import { BoardingVehiclePointingList } from "./BoardingVehiclePointingList";
import { BoardingOtherPointingList } from "./BoardingOtherPointingList";
import { BoardingCraftPointingList } from "./BoardingCraftPointingList";

export const BoardingPointingForm = () => {
  const { initialValue } = useContext(OperationContext);
  const [tabItems, setTabItems] = useState<Array<any>>([]);

  useEffect(() => {
    setTabItems(
      initialValue?.embarkationMovement?.loadPossessionStatus?.map(
        (item: any) => {
          return {
            ...item,
            key: item?.id,
            label: item?.name,
            children: setComponents(item?.id),
          };
        }
      )
    );
  }, [initialValue]);

  const setComponents = (id: string) => {
    switch (id) {
      case OperationConstant.CONTAINER_ID:
        return <BoardingContainerPointingList />;

      case OperationConstant.BAG_ID:
        return <BoardingBagPointingList />;

      case OperationConstant.VEHICLE_ID:
        return <BoardingVehiclePointingList />;

      case OperationConstant.CRAFT_ID:
        return <BoardingCraftPointingList />;

      case OperationConstant.OTHER_ID:
        return <BoardingOtherPointingList />;

      default:
        return <BoardingContainerPointingList />;
    }
  };
  return (
    <>
      <CustomTabs items={tabItems} tabName="type" />
    </>
  );
};
